import React from 'react';
import { Consumer as ItemManagersConsumer } from '@atlassian/jira-providers-item-managers/src/index.tsx';
import { ImperativeAPI as ImperativeAPIWrapped } from './controllers/index.tsx';

const ImperativeAPI = () => (
	<ItemManagersConsumer>
		{({ getManager }) => <ImperativeAPIWrapped getItemManager={getManager} />}
	</ItemManagersConsumer>
);

export { ImperativeAPI };
